import { render, staticRenderFns } from "./dock.vue?vue&type=template&id=dfeeffb0&scoped=true"
import script from "./dock.vue?vue&type=script&lang=js"
export * from "./dock.vue?vue&type=script&lang=js"
import style0 from "./dock.vue?vue&type=style&index=0&id=dfeeffb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfeeffb0",
  null
  
)

export default component.exports